import { createContext } from "react";

const PercentageProgressBarContext = createContext();

export default PercentageProgressBarContext;